import { render, staticRenderFns } from "./TipoMedidaPantalla.vue?vue&type=template&id=021dadec&"
import script from "./TipoMedidaPantalla.vue?vue&type=script&lang=ts&"
export * from "./TipoMedidaPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('021dadec', component.options)
    } else {
      api.reload('021dadec', component.options)
    }
    module.hot.accept("./TipoMedidaPantalla.vue?vue&type=template&id=021dadec&", function () {
      api.rerender('021dadec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TipoMedida/TipoMedidaPantalla.vue"
export default component.exports